<template>
  <header id="header" :class="['full-header', 'transparent-header', 'semi-transparent', 'd-none', 'd-lg-block', themeStore.isDark ? 'dark' : '', isSticky ? 'sticky-header sticky-header-shrink' : '']">
    <div 
      id="header-wrap" 
      :class="{ 'sticky-header-shrink': isSticky }" 
      :style="isSticky ? 'background-color: ' + (themeStore.isDark ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)') + ' !important; backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border-bottom: ' + (themeStore.isDark ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)') + ';' : ''"
    >
      
      <!-- Top Row: Logo e Menu Principal -->
      <div class="container-fluid" style="padding: 0 30px;">
        <div class="header-row justify-content-between">
          <!-- Logo de Texto -->
          <div id="logo">
            <router-link to="/" class="text-decoration-none" style="display: flex; align-items: center; height: 100%;">
              <span v-rubberband class="h3 mb-0 fw-bold font-cinzel" :class="themeStore.isDark ? 'text-white' : 'text-dark'" style="display: inline-block;">Bar Experts</span>
            </router-link>
          </div>

          <div class="primary-menu-trigger">
            <button class="cnvs-hamburger" type="button" title="Open Mobile Menu">
              <span class="cnvs-hamburger-box"><span class="cnvs-hamburger-inner"></span></span>
            </button>
          </div>

          <!-- Navigation Menu + Login/Logout no Topo Direita -->
          <nav class="primary-menu" v-rubberband>
            <ul class="menu-container">
              <li class="menu-item"><router-link class="menu-link text-danger" to="/campeonato"><div><i class="uil uil-trophy me-1" aria-hidden="true"></i>Campeonato</div></router-link></li>
              <li class="menu-item"><router-link class="menu-link" to="/cursos"><div>Cursos</div></router-link></li>
              <li class="menu-item"><router-link class="menu-link" to="/masterclass"><div>Masterclass</div></router-link></li>
              <!-- Login / Logout dinâmico -->
              <li class="menu-item" v-if="!auth.isAuthenticated">
                <a href="#" class="menu-link" @click.prevent="showLoginModal = true"><div>Login</div></a>
              </li>
              <li class="menu-item" v-else>
                <a href="#" class="menu-link" @click.prevent="handleLogout"><div>Logout</div></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!-- Bottom Row: Barra Fina (Tools) -->
      <transition name="slide-down">
        <div 
          class="header-tools-bar" 
          v-if="auth.isAuthenticated" 
        :style="{ 
          padding: '10px 0', 
          borderTop: themeStore.isDark ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)' 
        }"
      >
        <div class="container-fluid d-flex justify-content-end" style="padding: 0 30px;" v-rubberband>
          <nav class="d-flex align-items-center m-0 p-0" style="gap: 20px; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 1px;">
            

            <router-link v-if="auth.isAuditor" to="/admin/biblioteca" class="text-decoration-none fw-bold" :class="themeStore.isDark ? 'text-white' : 'text-danger'">Curadoria Acervo</router-link>

            <router-link v-if="auth.isAuditor" to="/admin/cursos" class="text-decoration-none fw-bold" :class="themeStore.isDark ? 'text-white-50' : 'text-black-50'">Gestão Cursos</router-link>

            <router-link v-if="auth.isAuditor" to="/admin/newsletter" class="text-decoration-none fw-bold d-flex align-items-center gap-1" :class="themeStore.isDark ? 'text-white-50' : 'text-black-50'">
              <i class="uil uil-whatsapp" style="color: #25d366; font-size: 1rem;"></i>Newsletter
            </router-link>

            <router-link v-if="auth.isConsultor" to="/painel" class="text-decoration-none fw-bold" :class="themeStore.isDark ? 'text-white' : 'text-danger'">Painel Consultor</router-link>

            <router-link v-if="auth.isAuditor" to="/admin/artigos" class="text-decoration-none fw-bold" :class="themeStore.isDark ? 'text-white-50' : 'text-black-50'">Redação</router-link>
            
            <router-link to="/mailbox" class="text-decoration-none fw-bold d-flex align-items-center gap-1" :class="themeStore.isDark ? 'text-white-50' : 'text-black-50'">
              <i class="bi bi-envelope-fill"></i> E-mail
            </router-link>
            
            <router-link v-if="auth.isSuperAdmin" to="/superadmin" class="text-decoration-none fw-bold text-danger">Modo Deus</router-link>
            
            <router-link 
              to="/dashboard" 
              class="text-decoration-none fw-bold ps-3 d-flex align-items-center" 
              :class="themeStore.isDark ? 'text-white' : 'text-dark'"
              :style="{ borderLeft: themeStore.isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)', gap: '10px' }"
            >
              <template v-if="auth.profilePictureUrl">
                <img :src="auth.profilePictureUrl" alt="Avatar" class="header-avatar-img">
              </template>
              <template v-else>
                <i class="bi-grid-fill text-danger fs-5"></i>
              </template>
              <span>{{ auth.nickname || 'Dashboard' }}</span>
            </router-link>
          </nav>
        </div>
      </div>
      </transition>
    </div>
    <div class="header-wrap-clone"></div>
    
    <!-- Modal de Login (Centralizado e Flutuante) -->
    <LoginModal v-if="showLoginModal" @close="showLoginModal = false" />
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useThemeStore } from '../stores/theme'
import { useCoursesStore } from '../stores/coursesStore'
import { useNotificationStore } from '../stores/notificationStore'
import LoginModal from './LoginModal.vue'

const route = useRoute()
const auth = useAuthStore()
const themeStore = useThemeStore()
const coursesStore = useCoursesStore()
const notificationStore = useNotificationStore()

const isSticky = ref(false)
const showLoginModal = ref(false)

const isCourseDetailPage = computed(() => {
  return route.path.startsWith('/cursos/') && route.params.slug
})

const isSlugValid = computed(() => {
  if (!coursesStore.activeEditForm.slug) return false
  return coursesStore.isSlugAvailable(coursesStore.activeEditForm.slug, route.params.slug)
})

const handleLogout = () => {
  auth.logout('/')
  notificationStore.notifySuccess('Você saiu da sua conta com segurança.')
}

const handleScroll = () => {
  isSticky.value = window.scrollY > 80
}

onMounted(() => {
  coursesStore.initStore()
  window.addEventListener('scroll', handleScroll)
  // Canvas requer essa classe no body para o transparent-header sobrepor o hero em telas grandes
  if (window.innerWidth >= 992) {
    document.body.classList.add('is-expanded-menu')
    document.body.classList.add('device-xl')
  }
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* =========================================
   Animação do Menu Secundário (Slide Down)
   ========================================= */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  transform-origin: top;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100%);
  max-height: 0;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border-color: transparent !important;
}

.slide-down-enter-to,
.slide-down-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 60px; /* altura máxima segura para a transição */
}

.header-avatar-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(128, 128, 128, 0.25);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  margin-top: -6px;
  margin-bottom: -6px;
  vertical-align: middle;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.header-avatar-img:hover {
  transform: scale(1.08);
  opacity: 0.9;
}

/* =========================================
   HD / 720p Display (1081px a 1365px)
   Redução de ~20% na altura do menu para não sufocar a tela
   ========================================= */
@media (min-width: 1081px) and (max-width: 1365px) {
  /* Reduz os paddings do menu principal */
  :deep(.primary-menu .menu-link) {
    padding-top: 25px !important;
    padding-bottom: 25px !important;
  }
  
  /* Diminui um pouco o tamanho da fonte do logo */
  #logo .h3 {
    font-size: 1.4rem !important;
  }

  /* Reduz a barra de ferramentas inferior */
  .header-tools-bar {
    padding: 6px 0 !important;
    transition: all 0.3s ease;
  }
  
  .header-tools-bar nav {
    font-size: 0.75rem !important;
  }

  /* =======================================
     Ainda mais compacto durante o SCROLL
     ======================================= */
  .sticky-header-shrink :deep(.primary-menu .menu-link) {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  
  .sticky-header-shrink #logo .h3 {
    font-size: 1.15rem !important;
  }

  /* Some com o padding da barra inferior durante o scroll para colar os elementos */
  .sticky-header-shrink .header-tools-bar {
    padding: 0 0 !important;
    border-top: none !important;
  }
}
</style>
